<template>
  <div>
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-alert
        :show="showAlert"
        variant="danger"
        class="p-1 mb-1"
      >
        <feather-icon
          icon="AlertCircleIcon"
          size="18"
          style="margin-right: 5px;"
        />
        No hay cambios en la configuración de grabaciones
      </b-alert>
      <b-alert
        :show="configRecordingInProccess"
        variant="info"
        class="p-1 mb-1"
      >
        <div class="d-flex align-items-center">
          <feather-icon
            icon="InfoIcon"
            size="18"
            style="margin-right: 5px;"
          />
          <span class="mr-1">La configuración de grabaciones se ha iniciado. El proceso puede tardar unos minutos.</span>
          <b-spinner label="Loading" variant="info" />
        </div>
      </b-alert>
      <b-form
        @submit.prevent="handleSubmit(checkChanges)"
        @reset.prevent="resetForm"
      >
        <div :class="['row mx-0 mb-1', (hasErrors) ? 'align-items-center' : 'align-items-end']">
          <div class="col-5 pl-0">
            <validation-provider
              #default="validationContext"
              name="Cámara"
              rules="required"
            >
              <b-form-group
                label="Cámara"
                label-for="camera"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.channel"
                  label="name"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="hanwhaDvr.cameras"
                  :clearable="false"
                  :reduce="(val) => val.channel"
                  :disabled="disabledInputs"
                  input-id="camera"
                  placeholder="Seleccionar cámara"
                  @input="cameraChange"
                />
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col-5 pl-0">
            <validation-provider #default="validationContext" name="Tipo">
              <b-form-group
                label="Tipo"
                label-for="recording-type"
                :state="getValidationState(validationContext)"
              >
                <v-select
                  v-model="itemData.type"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="recordingTypes"
                  :clearable="false"
                  :reduce="(val) => val.value"
                  :disabled="disabledInputs"
                  input-id="recording"
                  placeholder="Seleccionar tipo"
                >
                  <template #selected-option="option">
                    <div class="d-flex align-items-center">
                      <div :style="{
                        height: '22px',
                        width: '22px',
                        borderRadius: '3px',
                        background: option.color,
                        border: `1px solid ${((option.value === '0') ? '#dcdcdc' : option.color)}`
                      }"></div>
                      <span class="ml-1">{{ option.label }}</span>
                    </div>
                  </template>
                  <template v-slot:option="option">
                    <div class="d-flex align-items-center">
                      <div :style="{
                        height: '22px',
                        width: '22px',
                        borderRadius: '3px',
                        background: option.color,
                        border: `1px solid ${((option.value === '0') ? '#dcdcdc' : option.color)}`
                      }"></div>
                      <span class="ml-1">{{ option.label }}</span>
                    </div>
                  </template>
                </v-select>
                <b-form-invalid-feedback :state="getValidationState(validationContext)">
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </div>
          <div class="col-2 px-0">
            <button
              type="submit"
              class="btn btn-primary btn-block mb-1"
              :disabled="disabledInputs"
            >
              {{ buttonText }}
            </button>
          </div>
        </div>
      </b-form>
    </validation-observer>

    <div  v-if="loadingDataByChannel" class="d-flex justify-content-center my-2">
      <b-spinner label="Loading" variant="primary" />
    </div>

    <div class="d-flex">
      <div class="day-header">
          <button
            type="button"
            class="btn btn-sm btn-outline-primary btn-block"
            @click="selectAll()"
          >
            Todo
          </button>
      </div>
      <div class="d-flex">
        <div
            v-for="(hour, hourIndex) in hours"
            :key="hour.value"
            class="hour-header"
            @click="hourClick(hourIndex)"
        >
            {{ hour.value }}
        </div>
      </div>
    </div>
    <div
      v-for="(row, dayIndex) in scheduler"
      :key="dayIndex"
      class="d-flex"
    >

      <div class="day-header day-header-color" @click="dayClick(dayIndex)">
          {{ days[dayIndex].name }}
      </div>

      <div
        class="schedule-row"

      >
        <div
          v-for="(cell, hourIndex) in row"
          :key="hourIndex"
          :class="['cell', `mode-${cell}`, { selecting: isInSelection(dayIndex, hourIndex) }]"
          @click="cellClick(dayIndex, hourIndex)"
          @mousedown.prevent="startDrag(dayIndex, hourIndex)"
          @mouseenter="dragOver(dayIndex, hourIndex)"
          @mouseup="stopDrag"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed,onMounted,onUnmounted,ref } from "@vue/composition-api";
import { useToast } from "vue-toastification/composition";
import { required } from '@validations';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import vSelect from "vue-select";
import formValidation from '@core/comp-functions/forms/form-validation';
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import axios from "@axios";
import store from "@/store";

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    vSelect
  },
  props: {
    hanwhaDvr: {
      type: Object,
      require: true
    },
  },
  data() {
    return {
      required
    }
  },
  setup(props, { emit }) {
    const resetData = () => {
      itemData.value = {
        id_camera: null,
        channel: null,
        type: null
      }
    }

    //HOOKS
    onMounted(async () => await initData());

    onUnmounted(() => disconnectSockets());

    //COMPOSABLES
    const {
      refFormObserver,
      getValidationState,
      resetForm
    } = formValidation(resetData);

    const toast = useToast();

    //DATA
    const configRecordingInProccess = ref(false);

    const days = ref([
      {
        name: 'Domingo',
        selected: false
      },
      {
        name: 'Lunes',
        selected: false
      },
      {
        name: 'Martes',
        selected: false
      },
      {
        name: 'Miercoles',
        selected: false
      },
      {
        name: 'Jueves',
        selected: false
      },
      {
        name: 'Viernes',
        selected: false
      },
      {
        name: 'Sabado',
        selected: false
      },
      {
        name: 'Vacaciones',
        selected: false
      }
    ]);

    const dragStart = ref(null);

    const dragCurrent = ref(null);

    const hours = ref(
      Array.from({ length: 24 }, (_, i) => ({
          value: i,
          selected: false
      }))
    );

    const isDragging = ref(false);

    const itemData = ref({
      id_camera: null,
      channel: null,
      type: null
    });

    const loading = ref(false);

    const loadingDataByChannel = ref(false);

    const recordingTypes = ref([
      {
        value: '0',
        label: 'Sin grabaciones',
        color: '#FFF',
      },
      {
        value: '1',
        label: 'Grabación normal',
        color: '#05DF72',
      },
      {
        value: 'E',
        label: 'Evento',
        color: '#FB2C36',
      },
      {
        value: 'B',
        label: 'Grabación normal/Evento',
        color: '#FF8904'
      }
    ]);

    const scheduler = ref(
      Array.from({ length: days.value.length }, () =>
          Array.from({ length: hours.value.length }, () => '0')
      )
    );

    const schedulerOriginal = ref([]);

    const showAlert = ref(false);

    //COMPUTED
    const buttonText = computed(() => (loading.value) ? 'Guardando...' : 'Guardar');

    const disabledInputs = computed(() => (loading.value || configRecordingInProccess.value || loadingDataByChannel.value));

    const hasErrors = computed(() => {
      const errors = refFormObserver.value?.errors || {};

      return Object.values(errors).some(arr => arr.length > 0);
    });

    const user = computed(() => store.getters["user/getUser"]);

    //METHODS
    const cameraChange = async (channel) => {
      const cameraByChannel = props.hanwhaDvr.cameras.find(camera => (camera.channel === channel));

      itemData.value.id_camera = cameraByChannel.id;

      for (let day = 0; day < days.value.length; day++) {
        for (let hour = 0; hour < hours.value.length; hour++) {
          cellClick(day, hour, '0');
        }
      }

      await getRecordingInfoByCamera(cameraByChannel);
    }

    const cellClick = (dayIndex, hourIndex, value = null) => {
      const valueRectordingType = (value === null) ? itemData.value.type : value;

      scheduler.value[dayIndex].splice(
        hourIndex,
        1,
        valueRectordingType
      );
    }

    const checkChanges = async () => {
      const dayNames = [
        'SUN',
        'MON',
        'TUE',
        'WED',
        'THU',
        'FRI',
        'SAT',
        'HOL'
      ];

      const changes = [];

      showAlert.value = false;

      scheduler.value.forEach((day, dayIndex) => {
        day.forEach((value, hourIndex) => {
          const dayChange = (value !== schedulerOriginal.value[dayIndex][hourIndex]);

          if (dayChange) {
            changes.push({
              day: dayNames[dayIndex],
              hour: hourIndex,
              value
            });
          }
        });
      });

      if (!changes.length) {
        showAlert.value = true;
        return;
      }

      await onSubmit(changes);
    }

     const connectSockets = () => {
      disconnectSockets();

      window.Echo.private(`camera-recording-config-failed-${user.value.id}`)
        .listen('.recording-config-failed', (event) => setRecordingConfigFailedNotification(event));

      window.Echo.private(`camera-recording-config-success-${user.value.id}`)
        .listen('.recording-config-success', (event) => setRecordingConfigNotification(event));
    }

    const dayClick = (dayIndex) => {
      const selectedDay  = days.value[dayIndex];
      const rowDay       = scheduler.value[dayIndex];
      let rectordingType = 0;

      selectedDay.selected = !selectedDay.selected;
      rectordingType = (selectedDay.selected) ? null : '0';

      rowDay.forEach((_, hourIndex) => {
       cellClick(dayIndex, hourIndex, rectordingType);
      });
    }

    const disconnectSockets = () => {
      window.Echo.leave(`camera-recording-config-failed-${user.value.id}`);
      window.Echo.leave(`camera-recording-config-success-${user.value.id}`);
    }

    const dragOver = (dayIndex, hourIndex) => {
      if (!isDragging.value) {
        return;
      }

      dragCurrent.value = {
        day: dayIndex,
        hour: hourIndex
      }
    }

    const getRecordingInfoByCamera = async (camera) => {
        const params = {
          id_camera: camera.id
        }

        loadingDataByChannel.value = true;

        await axios.get('/v1/hanwha/camera/admin/get-recording-info', { params })
          .then(response => {
              const { data } = response;
              const [recordingConfig] = data.data.RecordSchedule;

              paintByRecordConfig(recordingConfig);
          })
          .finally(() => {
            loadingDataByChannel.value = false;
          });
    }

    const hourClick = (hourIndex) => {
      const selectedHour  = hours.value[hourIndex];
      let rectordingType = 0;

      selectedHour.selected = !selectedHour.selected;
      rectordingType = (selectedHour.selected) ? null : '0';

      scheduler.value.forEach((_, dayIndex) => {
        cellClick(dayIndex, hourIndex, rectordingType);
      });
    }

    const isInSelection = (dayIndex, hourIndex) => {
      if (!dragStart.value || !dragCurrent.value) {
        return false;
      }

      const minDay  = Math.min(dragStart.value.day, dragCurrent.value.day);
      const maxDay  = Math.max(dragStart.value.day, dragCurrent.value.day);
      const minHour = Math.min(dragStart.value.hour, dragCurrent.value.hour);
      const maxHour = Math.max(dragStart.value.hour, dragCurrent.value.hour);

      return (
        dayIndex >= minDay &&
        dayIndex <= maxDay &&
        hourIndex >= minHour &&
        hourIndex <= maxHour
      );
    }

    const initData = async () => {
      connectSockets();
      await selectChannel();
    }

    const onSubmit = async (scheduler) => {
      const params = {
        id_camera: itemData.value.id_camera,
        scheduler: scheduler
      }

      loading.value = true;

      await axios.post('/v1/hanwha/camera/admin/set-recording-config', params)
        .then(response => {
          configRecordingInProccess.value = true;
        })
        .catch(() => {

        })
        .finally(() => {
          loading.value = false;
        });
    }

    const paintSelection = () => {
      if (!dragStart.value || !dragCurrent.value) {
        return;
      }

      const minDay  = Math.min(dragStart.value.day, dragCurrent.value.day);
      const maxDay  = Math.max(dragStart.value.day, dragCurrent.value.day);
      const minHour = Math.min(dragStart.value.hour, dragCurrent.value.hour);
      const maxHour = Math.max(dragStart.value.hour, dragCurrent.value.hour);

      for (let day = minDay; day <= maxDay; day++) {
        for (let hour = minHour; hour <= maxHour; hour++) {
          scheduler.value[day].splice(hour, 1, itemData.value.type);
        }
      }
    }

    const paintByRecordConfig = (recordConfig) => {
      const daysMap = {
        SUN: 0,
        MON: 1,
        TUE: 2,
        WED: 3,
        THU: 4,
        FRI: 5,
        SAT: 6,
        HOL: 7
      };

      for (const key in recordConfig) {
        if (key === 'Channel') {
          continue
        }

        const dayIndex = daysMap[key];

        recordConfig[key].forEach((value, hourIndex) => {
          cellClick(dayIndex, hourIndex, value);
        });
      }

      updateDaysSelected();
      updateHoursSelected();

      schedulerOriginal.value = JSON.parse(JSON.stringify(scheduler.value));
    }

    const selectAll = () => {
      for (let day = 0; day < days.value.length; day++) {
        for (let hour = 0; hour < hours.value.length; hour++) {
          cellClick(day, hour);
        }
      }
    }

    const selectChannel = async () => {
      const { cameras = [] } = props.hanwhaDvr;

      showAlert.value = false;

      if (cameras.length) {
        const [camera] = cameras;

        itemData.value.id_camera = camera.id;
        itemData.value.channel   = camera.channel;

        await getRecordingInfoByCamera(camera);
      }
    }

    const setRecordingConfigNotification = (event) => {
      configRecordingInProccess.value = false;

      toast({
        component: ToastificationContent,
        props: {
          title: 'Configuración de grabaciones finalizada correctamente',
          icon: 'CheckIcon',
          variant: 'success',
        },
      });

      //refetchData();
    }

    const setRecordingConfigFailedNotification = (event) => {
      const { message } = event;

      configRecordingInProccess.value = false;

      toast({
        component: ToastificationContent,
        props: {
          title: message,
          icon: 'AlertTriangleIcon',
          variant: 'danger',
        },
      },{
        timeout: false
      });
    }

    const startDrag = (dayIndex, hourIndex) => {
       isDragging.value = true;

        dragStart.value = {
          day: dayIndex,
          hour: hourIndex
        }

        dragCurrent.value = {
          day: dayIndex,
          hour: hourIndex
        }
    }

    const stopDrag = () => {
      paintSelection();

      isDragging.value  = false;
      dragStart.value   = null;
      dragCurrent.value = null;
    }

    const updateDaysSelected = () => {
      scheduler.value.forEach((row, dayIndex) => {
        days.value[dayIndex].selected = row.every(value => value === row[0]);
      });
    }

    const updateHoursSelected = () => {
      hours.value.forEach((hour, hourIndex) => {
        const column = scheduler.value.map(row => row[hourIndex]);

        hour.selected = column.every(value => value === column[0]);
      });
    }

    return {
      getValidationState,
      resetForm,
      refFormObserver,

      configRecordingInProccess,
      days,
      hours,
      itemData,
      loading,
      loadingDataByChannel,
      recordingTypes,
      scheduler,
      showAlert,

      buttonText,
      disabledInputs,
      hasErrors,

      cameraChange,
      cellClick,
      checkChanges,
      dayClick,
      dragOver,
      hourClick,
      initData,
      isInSelection,
      onSubmit,
      selectAll,
      selectChannel,
      startDrag,
      stopDrag
    }
  }
}
</script>

<style scoped>
::v-deep .record-config-dialog {
    max-width: 61.5vw;
}

.schedule{
  display:flex;
  flex-direction:column;
}

.schedule-row, .schedule-row-header {
    display:flex;
    gap: 4px;
    margin-bottom: 5px;
}

.cell{
  width: 30px;
  height: 30px;
  border:1px solid #dcdcdc;
  border-radius: 4px;
  cursor: pointer;
}

.day-header{
  width: 90px;
  max-width: 90px;
  display: flex;
  align-items: center;
  margin-right: 5px;
  margin-bottom: 5px;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  user-select:none;
}

.day-header.day-header-color {
  padding-left: 8px;
  background: #f5f5f5;
}

.hour-header{
  width:34px;
  height:28px;
  display:flex;
  justify-content:center;
  align-items:center;
  font-size:13px;
  color:#555;
  cursor:pointer;
  user-select:none;
  border-radius: 3px;
  gap: 4px;
}

.mode-0 {
  background-color: #fff;
}

.mode-1 {
  background-color: #05DF72;
}

.mode-E {
  background-color: #FB2C36;
}

.mode-B {
  background-color: #FF8904;
}

.selecting{
  outline: 2px solid #1b3d53;
  outline-offset: -2px;
}
</style>
